import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { Container, Row, Col } from "reactstrap";
import NavigationComponent from "~/components/NavigationComponent";
import FooterComponent from "~/components/FooterComponent";
import { mailTo } from "~/utils/misc";

import styles from "./Contact.scss";

class ContactRoute extends React.Component {
  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  componentDidMount() {
    // Initialize perfect scrollbar
    $("#app").perfectScrollbar({ suppressScrollX: true });

    // Setup share buttons
    $(".social_buttons").ayoshare({
      counter: false,
      button: {
        google: true,
        facebook: true,
        pinterest: true,
        twitter: true,
        email: true
      }
    });
  }

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <div id="contact_route">
        <Container id="navigation">
          <NavigationComponent />
        </Container>

        <Container id="contact">
          <Row>
            <Col xs="12">
              <h1>Contact</h1>
              <p>
                If you’re experiencing any problems with either the online
                version or the desktop version of the games, please contact me
                at{" "}
                <a href="#" onClick={mailTo}>
                  contact@online-jigsaw-puzzles.com
                </a>. If you have any ideas for improvements or suggestions for
                new features, then please let me know.
                <br />
                <br />
                I’m always trying to improve these card games, so feedback is
                (both good and bad) is always welcome.
                <br />
                <br />
                Feel free to give us a like or a share below:
                <br />
                <br />
              </p>
              <div
                className="social_buttons"
                data-ayoshare="https://online-jigsaw-puzzles.com"
              />
            </Col>
          </Row>
        </Container>

        <Container id="footer">
          <FooterComponent />
        </Container>
      </div>
    );
  }
}

export default withStyles(styles)(ContactRoute);



// WEBPACK FOOTER //
// ./src/routes/contact/Contact.js